/**
 * Service Locator - Manages dependencies between services and the store
 *
 * This pattern helps break circular dependencies by providing a central
 * registry for services and the store. Services can access the store
 * through this locator instead of importing it directly.
 */

import type { RootState } from '../store/types';

// Define the store interface that services will use
export interface StoreService {
  getState: () => RootState;
  dispatch: <T>(action: T) => T;
}

export const ServiceLocator = {
  store: null as StoreService | null,

  // Register the store instance
  registerStore(store: StoreService) {
    this.store = store;
  },

  getStore(): StoreService {
    if (!this.store) {
      throw new Error(
        'Store not initialized in ServiceLocator. Make sure to call registerStore() first.'
      );
    }
    return this.store;
  },
};
